// extracted by mini-css-extract-plugin
module.exports = {"container":"da51a739f7--container--MIgMg"};